<template>
    <div id="footer" class="container-fluid">
        <div class="footer-pc container visible-lg">
            <div class="footer-con">
                <div class="footer-left">
                    <div class="fo-l-item" v-for="item in footerData" :key="item.title">
                        <p class="fo-title">{{ item.title }}</p>
                        <p class="fo-link" v-for="child in item.children" :key="item.title + child.title">
                            <router-link target="_blank" :to="child.url || ''">{{ child.title }}</router-link>
                        </p>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="fo-r-item" style="padding-left: 50px">
                        <p class="fo-title">联系我们</p>
                        <p class="fo-link">
                            <a>地址：{{ contactUsData.address }}</a>
                        </p>
                        <p class="fo-link">
                            <a>咨询热线: {{ contactUsData.phone }}</a>
                        </p>
                    </div>

                    <div class="fo-r-item">
                        <p class="fo-title">关注我们</p>
                        <div class="erweima-con">
                            <div class="erweima-item">
                                <img class="logo-pic" :src="contactUsData.followUsQy">
                                <p class="erweima-tip">企业公众号</p>
                            </div>
                            <div class="erweima-item">
                                <img class="logo-pic" :src="contactUsData.followUsWx">
                                <p class="erweima-tip">访客入园申请</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <p class="copy-txt">
                <a target="_blank" href="https://beian.miit.gov.cn/">{{ contactUsData.icp }}</a>｜
                <img style="display: inline-block;" src="../assets/image/gxtjh.png" alt="">
                陕公网安备 61060202000342号

                | © {{ contactUsData.copyRight }}
            </p>
        </div>

        <div class="footer-m container hidden-lg">
            <div class="f-m-list">
                <div class="f-m-item" v-for="item in footerData" :key="item.title"
                    :class="{ 'active': item.title === selectedTitle }" @click="changeSel(item.title);">
                    <div class="f-m-title">
                        <span class="f-m-title-txt">{{ item.title }}</span>
                        <span class="glyphicon glyphicon-menu-down"></span>
                    </div>

                    <div class="f-m-child-con">
                        <router-link tag="div" class="f-m-item" v-for="child in item.children"
                            :key="item.title + child.title" :to="child.url || ''">{{ child.title }}</router-link>
                        <!-- <div class="f-m-item" v-for="child in item.children" :key="item.title + child.title">{{ child.title }}</div> -->
                    </div>
                </div>
                <div class="f-m-item active">
                    <div class="f-m-title">
                        <span class="f-m-title-txt">联系我们</span>
                    </div>
                    <div class="f-m-child-con">
                        <div class="f-m-item">地址：{{ contactUsData.address }}</div>
                        <div class="f-m-item">咨询热线: {{ contactUsData.phone }}</div>
                    </div>
                </div>
                <div class="f-divider"></div>

                <div class="fo-r-item">
                    <p class="fo-title">关注我们</p>
                    <div class="erweima-con">
                        <div class="erweima-item">
                            <img class="logo-pic" :src="contactUsData.followUsQy">
                            <p class="erweima-tip">企业公众号</p>
                        </div>
                        <div class="erweima-item">
                            <img class="logo-pic" :src="contactUsData.followUsWx">
                            <p class="erweima-tip">访客入园申请</p>
                        </div>
                    </div>

                </div>

                <div class="f-divider"></div>
                <div class="copy-txt">
                    <a target="_blank" href="https://beian.miit.gov.cn/">{{ contactUsData.icp }}</a>
                    |
                    <img style="display: inline-block;" src="../assets/image/gxtjh.png" alt="">
                    陕公网安备 61060202000342号
                    | © {{ contactUsData.copyRight }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    contactUs,
} from '@/api/api'
export default {
    name: "Footer",
    data() {
        return {
            contactUsData: {},
            selectedTitle: '园区服务',
            footerData: [
                {
                    title: '园区服务',
                    children: [
                        {
                            title: "交通畅达",
                            url: "/service/service-detail/0",
                        },
                        {
                            title: "资源支持",
                            url: "/service/service-detail/1",
                        },
                        {
                            title: "服务贴心",
                            url: "/service/service-detail/2",
                        },
                        {
                            title: "设施完善",
                            url: "/service/service-detail/4",
                        },
                        // {
                        //     title: "政策优厚",
                        //     url: "/service/service-detail/9",
                        // },
                        {
                            title: "政企服务",
                            url: "/service/policy",
                        }
                    ]
                },
                {
                    title: '企业入驻',
                    children: [
                        {
                            title: '入驻流程',
                            url: '/enter-process/settlement/5'
                        },
                        {
                            title: '优惠政策',
                            url: '/enter-process/settlement/6'
                        }
                    ]
                },
            ]
        };
    },
    mounted() {
        contactUs().then(res => {
            if (res.code === 0 && res.data) {
                this.contactUsData = res.data;
            }
        })
    },
    methods: {
        changeSel(index) {
            this.selectedTitle = index;
        }
    }
};
</script>
<style scoped lang="scss">
@import "~@/assets/css/mixin.scss";

.footer-m {
    .erweima-con {
        @include flex(flex-start);
        gap: 8px;

        .erweima-item {
            width: 50%;

            img {
                width: 130px;
                height: 130px;
                display: inline-block;
            }

            text-align: center;
        }
    }

    padding-bottom: 30px;

    .f-divider {
        border-bottom: 1px solid #e1e1e1;
        margin: 24px 0;
    }

    .copy-txt {
        font-size: 10px;
        color: #999;
        text-align: justify;
    }

    * {
        transition: transform ease 0.5s;
    }

    .f-m-item.active {
        .glyphicon {
            transform: rotate(180deg);
        }

        .f-m-child-con {
            display: block;
        }
    }

    .f-m-child-con {
        display: none;
    }

    .f-m-item {
        color: #999999;
        font-size: 12px;
        line-height: 22px;
    }

    .f-m-title {
        @include flex(space-between, center);
        line-height: 36px;

        .glyphicon {
            color: #979797;
        }
    }

    .f-m-title-txt {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
    }

}

.footer-pc {
    padding-top: 30px;

    .copy-txt {
        text-align: center;
        font-size: 12px;
        color: #999999;
        padding: 24px 0;
    }
}

.footer-con {

    padding-bottom: 60px;
    border-bottom: 1px solid #eeeeee;

    .erweima-item+.erweima-item {
        margin-left: 30px;
    }

    .erweima-con {
        @include flex(flex-start);

        .erweima-tip {
            font-size: 12px;
            color: #999999;
            text-align: center;
        }

        img {
            width: 88px;
            height: 88px;
            margin-bottom: 6px;
        }
    }

    .fo-r-item+.fo-r-item {
        margin-left: 30px;
    }

    .fo-title {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 30px;
    }

    .fo-link {
        margin-bottom: 12px;

        a {
            font-size: 12px;
            color: #999999;
        }
    }

    @include flex(space-between, flex-start);

    .fo-l-item {
        width: 170px;
    }

    .footer-left {
        width: 50%;
        @include flex(flex-start);
        border-right: 1px solid #e8e8e8;

    }

    .footer-right {
        width: 50%;
        @include flex(flex-end, flex-start);

    }
}

@media screen and (max-width: 997px) {}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue